package services.auth.http

import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.rest.RestResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


/**
 * The response to change the password for a user
 */
/**
 * Response for
 */
@Serializable
sealed interface AddNewCompanyResponse : RestResponse<CompanyCode> {

  @Serializable
  @SerialName("good")
  data class Good internal constructor(override val data: CompanyCode) : AddNewCompanyResponse, RestResponse.GoodResponse<CompanyCode>

  @Serializable
  @SerialName("bad/Failed")
  data class Failed(
    val errorType: ErrorType,
  ) : AddNewCompanyResponse, RestResponse.BadResponse<CompanyCode> {

    enum class ErrorType {
      CompanyAlreadyExists,
      FailToFetch,
    }
  }

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: CompanyCode): AddNewCompanyResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(errorType: Failed.ErrorType): AddNewCompanyResponse = Failed(errorType)
  }
}
